class Milestones {
	stateClasses = {
		hidden: 'd-none',
	};

	constructor($el) {
		this.$el = $el;
		this.$slider = $el.find('[data-milestones="slider"]');
		this.$slides = $el.find('[data-milestones="slide"]');
		this.$prev = $el.find('[data-milestones="prev"]');
		this.$next = $el.find('[data-milestones="next"]');
		this.init();
	}

	init = () => {
		// dynamically import slick-carousel
		import('slick-carousel').then(() => {
			this.$slider.slick({
				dots: false,
				infinite: false,
				speed: 500,
				slidesToShow: 4,
				slidesToScroll: 1,
				adaptiveHeight: true,
				draggable: true,
				swipe: true,
				arrows: false,
				centerMode: false,

				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
						},
					},
				],
			});

			const slick = this.$slider.slick('getSlick');
			this.handleNavigationVisibility(slick);
		});

		this.$prev.on('click', () => {
			this.prev();
		});

		this.$next.on('click', () => {
			this.next();
		});

		this.$slider.on('afterChange', (e, slick) => {
			this.handleNavigationVisibility(slick);
		});
	};

	handleNavigationVisibility = slick => {
		// check if the slider is at the end
		if (slick.$slides.last().hasClass('slick-active')) {
			this.$next.addClass(this.stateClasses.hidden);
		} else {
			this.$next.removeClass(this.stateClasses.hidden);
		}
		// check if the slider is at the beginning
		if (this.$slider.slick('slickCurrentSlide') === 0) {
			this.$prev.addClass(this.stateClasses.hidden);
		} else {
			this.$prev.removeClass(this.stateClasses.hidden);
		}
	};

	next = () => {
		this.$slider.slick('slickNext');
	};

	prev = () => {
		this.$slider.slick('slickPrev');
	};
}

export default Milestones;
